import React from 'react';
import { CreditCard, Smartphone, Wifi, Check, ArrowRight } from 'lucide-react';

const EmbarqueFlowSection = () => {
  const steps = [
    {
      number: "01",
      icon: CreditCard,
      title: "Credencial NFC/Virtual",
      description: "Passageiro usa cartão físico NFC ou credencial virtual no próprio celular"
    },
    {
      number: "02",
      icon: Wifi,
      title: "Leitura NFC",
      description: "Identificação é capturada automaticamente pelo dispositivo do passageiro"
    },
    {
      number: "03",
      icon: Smartphone,
      title: "Envio Bluetooth",
      description: "Dados enviados via Bluetooth ao aplicativo do motorista em tempo real"
    },
    {
      number: "04",
      icon: Check,
      title: "Validação Instantânea",
      description: "App exibe foto e status (autorizado/bloqueado) com confirmação visual e por voz"
    },
    {
      number: "05",
      icon: Check,
      title: "Registro Automático",
      description: "Embarque validado e registrado automaticamente no sistema central"
    }
  ];

  return (
    <section id="embarque-flow" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#008080]/10 px-4 py-2 rounded-full border border-[#008080]/20 mb-6">
            <Wifi className="w-4 h-4 text-[#008080]" />
            <span className="text-sm font-medium text-[#008080]">Como Funciona</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Fluxo de Embarque <span className="text-[#007bff]">NFC + Bluetooth</span>
          </h2>
          <p className="text-xl text-gray-600">
            Validação remota exclusiva que elimina discussões e garante embarques seguros em segundos
          </p>
        </div>

        {/* Desktop Flow */}
        <div className="hidden lg:block max-w-7xl mx-auto mb-16">
          <div className="relative">
            {/* Connection line */}
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-[#007bff] via-[#008080] to-[#007bff] -translate-y-1/2 z-0"></div>
            
            <div className="relative grid grid-cols-5 gap-4">
              {steps.map((step, index) => {
                const Icon = step.icon;
                return (
                  <div key={index} className="relative z-10">
                    <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-[#007bff] hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                      <div className="flex flex-col items-center text-center">
                        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#007bff] to-[#008080] flex items-center justify-center mb-4 shadow-lg">
                          <Icon className="w-8 h-8 text-white" />
                        </div>
                        
                        <div className="text-3xl font-bold text-[#007bff] mb-3">
                          {step.number}
                        </div>
                        
                        <h3 className="text-lg font-bold text-gray-900 mb-2">
                          {step.title}
                        </h3>
                        
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Mobile Flow */}
        <div className="lg:hidden space-y-6 max-w-2xl mx-auto mb-16">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#007bff] to-[#008080] flex items-center justify-center shadow-lg">
                        <Icon className="w-7 h-7 text-white" />
                      </div>
                    </div>
                    
                    <div className="flex-grow">
                      <div className="text-2xl font-bold text-[#007bff] mb-2">
                        {step.number}
                      </div>
                      
                      <h3 className="text-lg font-bold text-gray-900 mb-2">
                        {step.title}
                      </h3>
                      
                      <p className="text-gray-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
                
                {index < steps.length - 1 && (
                  <div className="flex justify-center py-3">
                    <ArrowRight className="w-6 h-6 text-[#007bff] transform rotate-90" />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Highlight box */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-[#007bff] to-[#008080] rounded-3xl p-10 shadow-2xl text-white">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <Wifi className="w-10 h-10 text-white" />
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold mb-3">
                  Validação Remota Exclusiva
                </h3>
                <p className="text-xl text-white/90 leading-relaxed">
                  A tecnologia NFC + Bluetooth do WCOMPass é <span className="font-bold">única no mercado</span> de 
                  gestão de transporte condominial. Embarque rápido, sem discussão, com registro automático e 
                  segurança total.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmbarqueFlowSection;
